// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-special-screen special-btn\"> <i class=\"fa fa-slideshare\"></i><span data-bind=\"text: _labels.SPECIAL\"></span> </a>";
// Exports
export default code;